import React from 'react';
import { SITE_CONTENT } from '../constants';

interface NavbarProps {
  activePage: string;
  onPageChange: (pageId: string, mediaTitle?: string) => void;
  isFirstVisit?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ activePage, onPageChange, isFirstVisit }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { hero } = SITE_CONTENT;

  const handleClick = (id: string) => {
    onPageChange(id);
    setIsOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 bg-midnight/90 backdrop-blur-xl border-b border-gold/10 ${isFirstVisit ? 'opacity-0 animate-heroText' : 'opacity-100'}`}>
      <div className="w-full px-4 md:px-10 h-24 lg:h-36 flex items-center justify-between">
        
        {/* Estrema Sinistra: Logo Primario */}
        <div className="flex-shrink-0">
          <div className="cursor-pointer" onClick={() => handleClick('home')}>
            <div className="p-1 md:p-2 border-2 border-gold/30 bg-black/30">
              <img 
                src={hero.logos.primary} 
                alt="Logo Primario" 
                className="h-16 md:h-24 lg:h-26 w-auto object-contain brightness-[0.7] opacity-80" 
              />
            </div>
          </div>
        </div>

        {/* Centro: Menu di Navigazione */}
        <div className="hidden lg:flex flex-grow justify-center px-10">
          <div className="flex items-center space-x-10">
            {SITE_CONTENT.navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => handleClick(item.id)}
                className={`text-[11px] uppercase tracking-[0.25em] transition-all duration-300 relative py-2 ${
                  activePage === item.id ? 'text-gold' : 'text-white/60 hover:text-gold'
                }`}
              >
                {item.label}
                {activePage === item.id && (
                  <span className="absolute bottom-0 left-0 w-full h-px bg-gold animate-scaleInHorizontal" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Estrema Destra: Logo Secondario e Mobile Toggle */}
        <div className="flex items-center space-x-6 flex-shrink-0">
          {/* Mobile Toggle */}
          <button 
            className="lg:hidden text-gold p-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          <div className="cursor-pointer" onClick={() => handleClick('home')}>
            <div className="p-1 md:p-2 border-2 border-gold/30 bg-black/30">
              <img 
                src={hero.logos.secondary} 
                alt="Logo Secondario" 
                className="h-16 md:h-24 lg:h-28 w-auto object-contain brightness-[0.7] opacity-80" 
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-midnight border-t border-gold/20 py-10 px-8 space-y-6 animate-fadeIn h-[calc(100vh-96px)] overflow-y-auto">
          {SITE_CONTENT.navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => handleClick(item.id)}
              className={`block w-full text-left text-2xl font-serif transition-colors ${
                activePage === item.id ? 'text-gold' : 'text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;